type Column = { Header: string; accessor: string };
type Row = Record<string, string | number>;

type Props = {
    columns: Column[];
    data: Row[];
};

export default function LeaderboardTable({ columns, data }: Props) {
    return (
        <div className="admin-table-scroll leaderboard-table">
            <table className="admin-table">
                <thead>
                    <tr>
                        {columns.map((col) => (
                            <th key={col.accessor}>{col.Header}</th>
                        ))}
                    </tr>
                </thead>
                <tbody>
                    {data.length === 0 ? (
                        <tr>
                            <td colSpan={columns.length} className="admin-table__empty">
                                Žádné dokončené hry.
                            </td>
                        </tr>
                    ) : (
                        data.map((row, i) => (
                            <tr key={i}>
                                {columns.map((col, j) => {
                                    const value = row[col.accessor];
                                    const isFirst = j === 0;
                                    return (
                                        <td key={col.accessor} className={isFirst ? 'leaderboard-rank' : ''}>
                                            {isFirst ? <RankBadge rank={String(value)} /> : value}
                                        </td>
                                    );
                                })}
                            </tr>
                        ))
                    )}
                </tbody>
            </table>
        </div>
    );
}

function RankBadge({ rank }: { rank: string }) {
    const n = parseInt(rank, 10);
    const medal = n === 1 ? 'gold' : n === 2 ? 'silver' : n === 3 ? 'bronze' : '';
    return <span className={`rank-badge${medal ? ` rank-badge--${medal}` : ''}`}>{rank}</span>;
}
